import { applyMiddleware, createStore } from 'redux'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'
import rootReducer from './reducers/index'

const composeEnhancers =
  window.__REDUX_DEVTOOLS_EXTENSION__COMPOSE__ &&
  window.__REDUX_DEVTOOLS_EXTENSION__()

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunk)),
  composeEnhancers
)

export default store
